<template>
  <div class="container">
    <div class="bg">

      <div class="innerbox">
        <img src="../assets/images/signin_animal.png" alt="" />
        <div class="box-bg" :class="{ 'en': $i18n.locale == 'en' }">
          <div class="container-box" :class="{ 'zh': $i18n.locale == 'zh' }">
            <div class="title-box">
              <span>{{ $t('m.login.title') }}</span>
            </div>
            <div class="alert-red" v-if="$i18n.locale == 'zh'" :class="{ 'zh': $i18n.locale == 'zh' }">
              <div class="">{{ $t('m.login.pone') + $t('m.login.ptwo') }}</div>
              <!-- <div class="">{{ $t('m.login.ptwo') }}</div> -->
            </div>
            <div class="alert-red" v-else>
              <div class="">{{ $t('m.login.pone') }}</div>
              <div class="">{{ $t('m.login.ptwo') }}</div>
            </div>
            <div class="btn wechat" :class="{ unActive: !check }" @click="WeChatLogin()" v-if="isLocalhost || isCnHost">
              <div>
                <svg version="1.1" id="图层_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px" y="0px" viewBox="0 0 25.9 21" style="fill:#06C160;enable-background:new 0 0 25.9 21;"
                  xml:space="preserve">

                  <g>
                    <path class="st0" d="M9.6,13c0-0.5,0.1-1,0.3-1.5c0.4-1.1,1-2,1.9-2.8c0.7-0.6,1.5-1.1,2.4-1.5c0.7-0.3,1.3-0.5,2-0.6
		c0.4-0.1,0.9-0.1,1.3-0.1c0.3,0,0.6,0,0.9,0c0.1,0,0.1,0,0.1-0.1c-0.1-0.2-0.1-0.4-0.2-0.6c-0.4-1.4-1.3-2.6-2.4-3.5
		c-0.8-0.6-1.6-1.1-2.5-1.5c-0.7-0.3-1.5-0.5-2.3-0.7c-0.3-0.1-0.7-0.1-1-0.1C9.9,0,9.7,0,9.5,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0
		c0,0-0.1,0-0.1,0C8.8,0,8.5,0,8.1,0.1C7.2,0.2,6.3,0.4,5.5,0.7c-1,0.4-1.9,0.9-2.7,1.6c-1.2,1-2,2.2-2.5,3.7C0.1,6.4,0.1,6.8,0,7.3
		c0,0.1,0,0.3,0,0.4c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1C0,7.9,0,8,0,8c0,0.4,0.1,0.9,0.1,1.3c0.2,1.1,0.8,2.1,1.5,3
		c0.5,0.6,1.1,1,1.7,1.5c0.1,0.1,0.1,0.1,0.1,0.2c0,0.2,0,0.5-0.1,0.7c-0.1,0.4-0.2,0.9-0.3,1.3c0,0.1,0,0.1,0,0.2
		c0,0.2,0.3,0.3,0.5,0.2c0.4-0.2,0.7-0.5,1.1-0.7c0.4-0.2,0.8-0.5,1.2-0.6C6,15,6.2,15,6.4,15.1c0.2,0.1,0.3,0.1,0.5,0.2
		c0.6,0.2,1.2,0.3,1.8,0.4c0.3,0,0.7,0,1,0c0.1,0,0.2,0,0.4,0c0,0,0-0.1,0-0.1C9.7,14.7,9.6,13.9,9.6,13z M12.5,4
		c0.7,0,1.3,0.6,1.3,1.3c0,0.7-0.5,1.3-1.3,1.3c-0.7,0-1.3-0.6-1.3-1.3C11.2,4.5,11.8,4,12.5,4z M6.2,6.6C5.5,6.6,4.9,6,4.9,5.3
		C4.9,4.6,5.5,4,6.3,4c0.7,0,1.3,0.5,1.3,1.3C7.6,6.1,7,6.6,6.2,6.6z" />
                    <path class="st0" d="M25.9,13.6c0-0.3,0-0.6-0.1-0.9c-0.2-1.1-0.7-2.1-1.5-2.9c-0.7-0.8-1.6-1.4-2.6-1.8c-1-0.4-2-0.7-3.1-0.7
		c-0.4,0-0.8,0-1.2,0c-0.4,0-0.7,0.1-1.1,0.1c-1.5,0.3-2.8,0.9-3.9,1.9c-0.6,0.6-1.2,1.2-1.5,2c-0.5,1-0.7,2-0.5,3.1
		c0.1,0.6,0.2,1.2,0.5,1.8c0.6,1.2,1.5,2.1,2.7,2.8c0.9,0.5,1.8,0.9,2.8,1.1c0.4,0.1,0.8,0.1,1.2,0.2c0.3,0,0.7,0,1,0
		c0.2,0,0.4,0,0.6-0.1c0.5-0.1,0.9-0.2,1.4-0.4c0.2-0.1,0.4-0.1,0.6,0c0.3,0.2,0.7,0.3,1,0.5c0.3,0.2,0.6,0.3,0.8,0.5
		c0.1,0.1,0.2,0.1,0.3,0c0.1-0.1,0.1-0.2,0.1-0.3c0,0,0-0.1,0-0.1c-0.1-0.5-0.3-1-0.3-1.5c0-0.2,0-0.3,0.2-0.4
		c0.3-0.2,0.7-0.5,1-0.8c1.1-1.1,1.8-2.4,1.8-4c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1C25.9,13.7,25.9,13.6,25.9,13.6z M15.5,12.7
		c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1C16.6,12.2,16.1,12.7,15.5,12.7z M20.7,12.7
		c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1C21.8,12.2,21.3,12.7,20.7,12.7z" />
                  </g>
                </svg>

                <span class="login-text">{{ $t('m.login.wechat') }}</span>
              </div>
            </div>
            <!-- v-if="isLocalhost || !isCnHost" -->
            <div class="btn qq" :class="{ unActive: !check }" @click="QQLogin()" v-if="isLocalhost || isCnHost">
              <div>
                <svg version="1.1" id="图层_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px" y="0px" viewBox="0 0 21.9 26.1" style="enable-background:new 0 0 21.9 26.1;"
                  xml:space="preserve">

                  <path class="st0" style="fill: #FAAB07;"
                    d="M11,25.8c-2.3,0-4.4-0.8-5.7-1.9c-0.7,0.2-1.6,0.5-2.1,0.9c-0.5,0.3-0.4,0.7-0.3,0.8C3.2,26.3,9.2,26.1,11,25.8
	L11,25.8z M11,25.8c2.3,0,4.4-0.8,5.7-1.9c0.7,0.2,1.6,0.5,2.1,0.9c0.5,0.3,0.4,0.7,0.3,0.8C18.7,26.3,12.7,26.1,11,25.8L11,25.8z" />
                  <path
                    d="M11,12.2c3.8,0,6.8-0.8,7.8-1c0.2-0.1,0.4-0.2,0.4-0.2c0,0,0-0.6,0-0.9c0-5-2.4-10-8.2-10C5.2,0,2.8,5,2.8,10
	c0,0.3,0,0.9,0,0.9c0,0,0.1,0.1,0.3,0.2C4,11.4,7.1,12.1,11,12.2L11,12.2z M21.2,16.3c-0.2-0.7-0.5-1.6-0.9-2.5c0,0-0.2,0-0.3,0
	c-2.9,0.8-6.4,1.4-9,1.3h0c-2.6,0-6.1-0.5-9-1.3c-0.1,0-0.3,0-0.3,0c-0.3,0.8-0.6,1.7-0.9,2.5c-1.1,3.6-0.7,5-0.5,5.1
	c0.6,0.1,2.3-2.7,2.3-2.7c0,2.8,2.5,7.1,8.3,7.1H11c5.8,0,8.3-4.3,8.3-7.1c0,0,1.7,2.8,2.3,2.7C21.9,21.4,22.3,19.9,21.2,16.3" />
                  <path class="st1" style="fill: #FFFFFF;" d="M8.9,7.4c-0.8,0-1.5-0.9-1.5-2c0-1.1,0.6-2.1,1.4-2.1c0.8,0,1.5,0.9,1.5,2C10.3,6.4,9.7,7.4,8.9,7.4 M14.5,5.4
	c0,1.1-0.7,2-1.5,2c-0.8,0-1.4-1-1.3-2.1c0-1.1,0.7-2,1.5-2C14,3.3,14.6,4.3,14.5,5.4" />
                  <path d="M9.9,5.4c0,0.5-0.2,0.9-0.6,0.9C9,6.4,8.7,6,8.6,5.6c0-0.5,0.2-0.9,0.6-0.9C9.5,4.6,9.8,5,9.9,5.4 M12,5.6
	c0.1-0.1,0.5-0.8,1.5-0.5c0.3,0.1,0.4,0.2,0.4,0.2c0,0.1,0,0.1,0,0.2c-0.1,0.2-0.2,0.2-0.3,0.2c-0.1,0-0.7-0.5-1.4,0.2
	c0,0-0.1,0.1-0.2,0C12,5.8,12,5.6,12,5.6" />
                  <path class="st1" style="fill: #FFFFFF;" d="M11,15.1L11,15.1c-1.8,0-4-0.2-6.2-0.6c-0.2,1.1-0.3,2.4-0.2,4c0.2,4,2.6,6.5,6.3,6.5H11c3.7,0,6-2.5,6.3-6.5
	c0.1-1.6,0-2.9-0.2-4C15,14.8,12.8,15.1,11,15.1" />
                  <path class="st2" style="fill: #EB1923;" d="M19.1,11c0,0-3.5,1.1-8.2,1.1h0c-4.6,0-8.1-1.1-8.2-1.1l-1.2,2.9c1.3,0.4,2.7,0.7,4.2,1v3.8
	c0,0,1.8,0.4,3.6,0.1v-3.5c0.5,0,1,0,1.5,0h0c2.8,0,6.4-0.5,9.3-1.4L19.1,11z" />
                  <path class="st3" style=" fill: #F8AD08;"
                    d="M16,9c0-0.3-2.3-1-5-1s-5,0.7-5,1c0,0.4,2.4,1.7,5,1.7C13.6,10.6,16,9.3,16,9z" />
                </svg>

                <span class="login-text">{{ $t('m.login.qq') }}</span>
              </div>
            </div>
            <!-- v-if="isLocalhost || !isCnHost" -->
            <div class="btn google" :class="{ unActive: !check }" @click="GoogleLogin()" v-if="isLocalhost || !isCnHost">
              <div>
                <svg version="1.1" id="图层_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px" y="0px" viewBox="0 0 24.3 24.3" style="enable-background:new 0 0 24.3 24.3;"
                  xml:space="preserve">

                  <path class="st0" style="fill: #FFC107;" d="M24.1,9.8h-1V9.7H12.2v4.9H19c-1,2.8-3.7,4.9-6.9,4.9c-4,0-7.3-3.3-7.3-7.3s3.3-7.3,7.3-7.3
	c1.9,0,3.6,0.7,4.8,1.8l3.4-3.4c-2.2-2-5.1-3.3-8.3-3.3C5.4,0,0,5.4,0,12.2s5.4,12.2,12.2,12.2s12.2-5.4,12.2-12.2
	C24.3,11.3,24.2,10.5,24.1,9.8z" />
                  <path class="st1" style="    fill: #FF3D00;" d="M1.4,6.5l4,2.9c1.1-2.7,3.7-4.6,6.8-4.6c1.9,0,3.6,0.7,4.8,1.8l3.4-3.4c-2.2-2-5.1-3.3-8.3-3.3
	C7.5,0,3.4,2.6,1.4,6.5z" />
                  <path class="st2" style=" fill: #4CAF50;" d="M12.2,24.3c3.1,0,6-1.2,8.1-3.2L16.5,18c-1.2,0.9-2.7,1.5-4.4,1.5c-3.2,0-5.8-2-6.9-4.8l-4,3.1
	C3.3,21.6,7.4,24.3,12.2,24.3z" />
                  <path class="st3" style="fill: #1976D2;" d="M24.1,9.8h-1V9.7H12.2v4.9H19c-0.5,1.4-1.4,2.5-2.5,3.4c0,0,0,0,0,0l3.8,3.2c-0.3,0.2,4-2.9,4-9
	C24.3,11.3,24.2,10.5,24.1,9.8z" />
                </svg>
                <span class="login-text">{{ $t('m.login.google') }}</span>
              </div>
            </div>

            <div class="btn facebook" @click="FacebookLogin()" v-if="isLocalhost || !isCnHost">
              <div>
                <svg version="1.1" id="图层_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px" y="0px" viewBox="0 0 24.3 24.2" style="enable-background:new 0 0 24.3 24.2;"
                  xml:space="preserve">

                  <path class="st0" style="fill: #1877F2;"
                    d="M24.3,12.2C24.3,5.4,18.9,0,12.2,0C5.4,0,0,5.4,0,12.2c0,6.1,4.4,11.1,10.3,12v-8.5H7.2v-3.5h3.1V9.5
	c0-3,1.8-4.7,4.6-4.7c1.3,0,2.7,0.2,2.7,0.2v3H16c-1.5,0-2,0.9-2,1.9v2.3h3.4l-0.5,3.5h-2.8v8.5C19.9,23.3,24.3,18.2,24.3,12.2" />
                </svg>

                <span class="login-text">{{ $t('m.login.facebook') }}</span>
              </div>
            </div>

            <div class="btn-box" :class="{ 'zh': $i18n.locale == 'zh' }">
              <div class="checkbox" :class="{ 'active': check == 1 }" @click="checkbox"><svg version="1.1" id="图层_1"
                  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                  viewBox="0 0 12.3 8.9" style="enable-background:new 0 0 12.3 8.9;" xml:space="preserve">

                  <path class="st0"
                    d="M11.9,0.9l-0.4-0.4c-0.6-0.6-1.5-0.6-2.1,0l-4,4L3,2.1c-0.6-0.6-1.5-0.6-2.1,0L0.4,2.6c-0.6,0.6-0.6,1.5,0,2.1
                                                                                          	l3.4,3.4v0l0.4,0.4c0.6,0.6,1.5,0.6,2.1,0l0.4-0.4L11.9,3C12.5,2.4,12.5,1.4,11.9,0.9z" />
                </svg></div>
              <div class="text">
                {{ $t('m.login.text') }}
             
                <a href="https://partyanimals.com/privacy-policy" v-if="$i18n.locale == 'en'">
                  {{ $t('m.login.privacy') }}</a>
                <a href="https://partyanimals.cn/privacy-policy" v-if="$i18n.locale == 'zh'">
                  {{ $t('m.login.privacy') }}</a>
                {{ $t('m.login.and') }}
                <a href="https://partyanimals.com/user-agreement" v-if="$i18n.locale == 'en'">{{
                  $t('m.login.eula')
                }}</a>
                <a href="https://partyanimals.cn/user-agreement" v-if="$i18n.locale == 'zh'">{{ $t('m.login.eula')
                }}</a>
                <div class="alert" v-if="check == 2"><svg data-v-cc53d074="" data-v-700d1935="" version="1.1" id="图层_1"
                    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    viewBox="0 0 22 22" xml:space="preserve"
                    style="width: 14px; fill-rule: evenodd; clip-rule: evenodd; fill: rgb(244, 109, 91);margin:2px 4px -2px 0">
                    <g data-v-cc53d074="" data-v-700d1935="">
                      <path data-v-cc53d074="" data-v-700d1935="" d="M11,0C4.9,0,0,4.9,0,11s4.9,11,11,11s11-4.9,11-11S17.1,0,11,0z M11,19.1c-4.5,0-8.1-3.6-8.1-8.1
		S6.5,2.9,11,2.9s8.1,3.6,8.1,8.1S15.5,19.1,11,19.1z" class="st0"></path>
                      <path data-v-cc53d074="" data-v-700d1935=""
                        d="M11,12.3c0.9,0,1.6-0.7,1.6-1.6V6.1c0-0.9-0.7-1.6-1.6-1.6S9.4,5.2,9.4,6.1v4.6C9.4,11.6,10.1,12.3,11,12.3z"
                        class="st0"></path>
                      <circle data-v-cc53d074="" data-v-700d1935="" cx="11" cy="15.2" r="1.9" class="st0">
                      </circle>
                    </g>
                  </svg> {{ $t('m.login.alert') }}</div>
              </div>
            </div>

          </div>

        </div>
        <div class="bottom-shadow">

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
let sha256 = require("js-sha256").sha256;

export default {
  inject: ['reload'],
  data() {
    return {
      check: 0,
      isCnHost: this._isCnHost(),
      isLocalhost: this._isLocalhost()
    };
  },
  mounted() {

  },
  methods: {
    _isCnHost() {
      let preferredLang =
        localStorage.getItem("preferredLang") ||
        navigator.language ||
        navigator.userLanguage ||
        navigator.browserLanguage ||
        "en";
      console.log(preferredLang);
      if (preferredLang != 'en') {
        return true
      }
      return false
    },

    _isLocalhost() {
      if (location.origin.includes('localhost')) {
        return true
      }
      return false
    },
    iptCustId() {

      this.$store.commit("LOGIN", true, custId);
      this.$router.push('/')
    },
    getCookie(name) {
      var strcookie = document.cookie; //获取cookie字符串
      var arrcookie = strcookie.split("; "); //分割
      //遍历匹配
      for (var i = 0; i < arrcookie.length; i++) {
        var arr = arrcookie[i].split("=");
        if (arr[0] == name) {
          return arr[1];
        }
      }
      return "";
    },
    checkbox() {
      if (this.check != 1) {
        this.check = 1
      } else {
        this.check = 0
      }
    },
    deleteCookie(name) {
      document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    },
    WeChatLogin() {
      if (this.check == 1) {
        localStorage.setItem('result_code', '');
        this.deleteCookie('cust_id_game');
        window.open(`${this.$backend.host}/wechat/begin_auth`, 'newwindow', 'popup')
      } else {
        this.check = 2
      }

    },
    QQLogin() {
      if (this.check == 1) {
        localStorage.setItem('result_code', '');
        this.deleteCookie('cust_id_game');
        window.open(`${this.$backend.host}/qq/begin_auth`, 'newwindow', 'popup')
      } else {
        this.check = 2
      }

    },
    GoogleLogin() {
      if (this.check == 1) {
        localStorage.setItem('result_code', '');
        this.deleteCookie('cust_id_game');
        window.open(`${this.$backend.host}/google/begin_auth`, 'newwindow', 'popup')
      } else {
        this.check = 2
      }

    },
    FacebookLogin() {
      if (this.check == 1) {
        localStorage.setItem('result_code', '');
        this.deleteCookie('cust_id_game');
        // window.open(`${this.$backend.host}/facebook/begin_auth`, 'newwindow', 'popup')
        window.open(`${this.$backend.host}/facebook/begin_auth`, 'newwindow', 'popup')
      } else {
        this.check = 2
      }

    },
    SteamLogin() {
      localStorage.setItem('result_code', '');
      window.open(`${this.$backend.host}/steam/begin_auth`, 'newwindow', 'popup')
    },
    XboxLogin() {
      localStorage.setItem('result_code', '');
      window.open(`${this.$backend.host}/xbox/begin_auth`, 'newwindow', 'popup')
      var count = 0
      let timer = setInterval(() => {
        count++
        if (count >= 100) {
          clearInterval(timer)
        }
        if (this.getCookie('result_code') != '') {
          // this.reload()
          console.log(this.$udesk);
          clearInterval(timer)
        }

      }, 200);
    }
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/login.scss";
</style>